import React from 'react';
import PropTypes from 'prop-types';
import wrapReact from '../../../util/react';
import './index.less';
import Menu from './Menu';

export const MenuSider = (props) => {
  const { filePath, className, ui } = props;
  return (
    <Menu
      className={`${filePath} ${className}`}
      mode="inline"
      theme="light"
      ui={ui.uiMenu}
    />
  );
};

MenuSider.propTypes = {
  ui: PropTypes.shape({
    uiMenu: PropTypes.object.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default wrapReact(MenuSider, 'container_home_menu_MenuSider');
